import API from './Api'

const endpointBaseUrl = 'sitesettings';

class SiteSettingsService {
    baseUrl() {
        return endpointBaseUrl;
    }

    getSiteSettings() {
        return API.get(endpointBaseUrl);
    }

    getSiteSetting(id) {
        return API.get(endpointBaseUrl + '/' + id);
    }
}

export default new SiteSettingsService();